import { ChannelType } from './notification-type'
import { stub } from '@adex/shared/utils/stub'


export interface INotificationBase {
  id: number
  channelName: string
  channelType: ChannelType
  lastNotification: string
  isDefault: boolean
}


export interface INotificationEmail extends INotificationBase {
  channelType: ChannelType.email
  email: string
}


export interface INotificationTelegram extends INotificationBase {
  channelType: ChannelType.telegram
  apiToken: string
  chatId: string
}


export interface INotificationSlack extends INotificationBase {
  channelType: ChannelType.slack
  token: string
  channel: string
}


export type NotificationType = INotificationEmail | INotificationTelegram | INotificationSlack

export const getEmailNon: ((n: NotificationType) => INotificationEmail) = stub as any
export const getTgNon: ((n: NotificationType) => INotificationTelegram) = stub as any
export const getSlNon: ((n: NotificationType) => INotificationSlack) = stub as any

